<template>
    <div>
        <public-title >
            打款记录列表
            <!-- <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回上一页</span> -->
        </public-title>
        <div class="load-area businesslist" >
            <div class="d-center-between flex-wrap">
                <left-text-border class="w-45 mb-3" leftText="打款号" v-model="Formdata.pay_id"/>
                <left-text-border class="w-45 mb-3" leftText="订单号"  v-model="Formdata.oid"/>
                <div class="w-45 mb-3 d-center-start" >
                    <el-select v-model="timeType" placeholder="时间查询" size="small" class="mr-1" style="width:260px;">
                        <el-option v-for="item in timeChoose" :key="item.value" :label="item.name" :value="item.value" />
                    </el-select>
                    <el-date-picker v-model="timestamp" type="daterange" class="w-100" size="small"
                            v-show="$GFUN.isInArray(['timeFrame','postTime','dealTime'],timeType)"
                            range-separator="至" value-format="timestamp" start-placeholder="开始时间"
                            end-placeholder="结束时间" />
                    <el-date-picker type="date" v-model="timetime" class="w-100" size="small" 
                                    v-show="timeType === 'timeArr'" placeholder="可选择一个日期"/>
                </div>
            </div>
            <div class="d-center-between mb-3"> 
                <div class="text-left ml-2 text-blue cops-text"></div>
                <el-button type="primary" size="small" @click="PsotBusinessPayment()">搜索</el-button>
            </div>
            <p v-if="total<=0" class="mt-3">当前没有数据</p>
            <ul class="list-head mt-3" v-else>
              <li  v-for="item in titleArrTravelList" :key="item" :class="item=='银行卡号'? 'w-80' : item=='操作'?'w-40':'w-50'" v-html="item"></li>
            </ul>
            <ul class="list-item" v-for="item in BusinessList" :key="item.id">
            <li class="w-50 list-item-col">{{item.pay_id}}</li>
            <li class="w-50 list-item-col flex-column breakword goHotelDetail">{{item.oid}}</li>
            <li class="w-50 list-item-col">{{item.truename}}</li>
            <li class="w-50 list-item-col">{{item.bank_name}}</li>
            <li class="w-50 list-item-col">{{item.branch}}</li>
            <li class="w-80 list-item-col">{{item.bank_card}}</li>
            <li class="w-50 list-item-col red">{{item.payment_pay/100 | formatMoney}}</li>
            <li class="w-50 list-item-col">{{item.charge/100 | formatMoney}}</li>
            <li class="w-50 list-item-col">{{item.add_time| formatTimestamp(1)}}</li>
            <template v-for="arr in tabArr">
                <li class="w-50 list-item-col" :key="arr.id" v-if="arr.id==item.status " :class="arr.value" >{{arr.label}}</li>
            </template>
            <li class="w-40 list-item-col">
                <el-dropdown @command="handleCommand($event,item)">
                <span class="el-dropdown-link text-link">查看<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item  command="1">订单详情</el-dropdown-item>
                    <el-dropdown-item  command="2" :disabled="item.status==2?false:true">查看回单</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
            </li>
            </ul>
            <el-pagination background layout="prev, pager, next" class="mt-4"  :page-size="10"
            :total="total" :current-page="Number(page)"
            @current-change="v => businessPayment(v)"/>
        </div>
        <el-dialog title="打款回单" :visible.sync="dialogFormVisible" width="1400px" class="paymentist" >
            <Receipt :receiptInfo="receiptInfo"></Receipt>
        </el-dialog>
    </div>
</template>
<script>
    import { mapState,mapGetters,mapActions } from 'vuex'
    import Receipt from '../../Admin/FinancialManage/FinancialStats/Receipt.vue'
    export default {
        name:'FinancialList',
        components: { Receipt},
        computed: {
            ...mapGetters(['storeInfo']),
            timeChoose() {
                let arr =  [
                {name:`按时间段`,value:'timeFrame'},
                {name:`按日期`,value:'timeArr'},
                ];
                return arr
            },
            //路由中的酒店ID，存在时判断为集团酒店获取日历
            store_id() { return this.$route.query.store||this.storeInfo.storeId},
        },
        data() {
            return {
                timeType:'timeFrame',
                Formdata:{
                    pay_id:'',                            //交易ID
                    oid:'',                               //订单ID
                    handle_time:''                        //按时间
                },
                timetime:'',
                 timestamp: [],
                titleArrTravelList:['打款号','订单号','企业名称/个人姓名','开户银行','支行名称','银行卡号','打款金额(元)','手续费(元)','处理时间','状态','操作'],
                BusinessList:[],
                total:0,
                page:1,
                tabArr:[{id:1,value:'red',label:'平台待打款'},{id:2,value:'green',label:'平台已打款'},{id:3,value:'gray',label:'打款失败'}],
                dialogFormVisible:false,
                receiptInfo:{},
            }
        },
        mounted() {
            this.PsotBusinessPayment();
        },
        watch: {
            //接收到消息更新列表
            newMessageInform (newVal) {
                if(newVal.type==107){
                    this.PsotBusinessPayment(1);
                }
            },
        },
        methods: {
            ...mapActions(['businessPayment']),
            PsotBusinessPayment(v){
                let data={
                    page:v?v:this.page,
                    ...this.Formdata,
                    store_id:this.store_id,
                }
                if(this.timetime!=''||this.timestamp.length!=0){
                    let start = this.timestamp && this.timestamp.length > 0 ? this.timestamp[0] / 1000 : '';
                    let end = this.timestamp && this.timestamp.length > 0 ? this.timestamp[1] / 1000 + 86399 : '';
                    switch (this.timeType) {
                        case 'timeArr':
                        let timeArr = this.timetime.getTime() / 1000;
                        data.handle_time = timeArr;
                        break;
                        case 'timeFrame':
                        data.handle_time = start?start+','+end:'';
                        break;
                    }
                }
                this.businessPayment({
                    data:data,
                    successFun:(res) => {
                        console.log(res);
                        this.total=res.count;
                        this.BusinessList=res.list;
                    }
                })
            },
            //点击操作按钮
            handleCommand(command,Itemize) {
                let htis = this;
                switch (command) {
                case '1':
                    this.goHotelDetail(Itemize)
                    break
                case '2':
                    this.receiptInfo=Itemize;
                    this.dialogFormVisible=true
                    break
                case '3':
                break
                }
            },
            //订单详情页
            goHotelDetail (e) {
                let cardItem=e;
                let routeUrl = this.$router.resolve({
                    name: 'OrderDetail',
                    query: {
                        orderType: 3,
                        orderId: cardItem.oid,
                        storeId: this.storeInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
                    }
                });
                window.open(routeUrl.href, '_blank');
            },
        }
    }
</script>